import { EndType } from '@wix/ambassador-pricing-plans-v3-plan/types';

/**
 * @returns true if plan is subscription based.
 */

export const isRecurringPlanV3 = plan => {
  var _plan$pricingVariants;
  const billingTerms = plan == null || (_plan$pricingVariants = plan.pricingVariants) == null || (_plan$pricingVariants = _plan$pricingVariants[0]) == null ? void 0 : _plan$pricingVariants.billingTerms;
  if ((billingTerms == null ? void 0 : billingTerms.endType) === EndType.UNTIL_CANCELLED) {
    return !!(billingTerms != null && billingTerms.billingCycle);
  }
  if ((billingTerms == null ? void 0 : billingTerms.endType) === EndType.CYCLES_COMPLETED) {
    var _billingTerms$cyclesC;
    return (billingTerms == null || (_billingTerms$cyclesC = billingTerms.cyclesCompletedDetails) == null ? void 0 : _billingTerms$cyclesC.billingCycleCount) !== '1';
  }
  return false;
};
//# sourceMappingURL=is-recurring-plan-v3.js.map